import { env } from '@/env';

// This will only work in client components.
export const getRestApiUrl = () => {
  const path = env.NEXT_PUBLIC_REST_API_ENDPOINT;

  if (path.startsWith('http')) {
    return path;
  }
  if (typeof window === 'undefined') {
    return env.NEXT_PUBLIC_DEFAULT_REST_API_ENDPOINT;
  }
  return `https://${window.location.host}${path}`;
};
